import { Pipe, PipeTransform } from '@angular/core';
import { UserGeneralRecord, UserRecord } from '@libs/shared/api';

@Pipe({
  name: 'avatarFileKey',
  standalone: true,
})
export class AvatarFileKeyPipe implements PipeTransform {
  transform(user: UserRecord | UserGeneralRecord): string {
    return user.profileImageFileKey ? user.profileImageFileKey : user.id;
  }
}
